const toPositiveInteger = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number) || number <= 0) return 0;
  return Math.floor(number);
};

export const getContactUnreadMessageCount = (
  contact,
  { staffId, isAdminView = false } = {},
) => {
  if (!contact) return 0;

  const unreadCounts = contact.unreadCounts || {};
  const counts =
    unreadCounts &&
    typeof unreadCounts === "object" &&
    !Array.isArray(unreadCounts)
      ? unreadCounts
      : {};

  const count = isAdminView
    ? Math.max(...Object.values(counts).map(toPositiveInteger), 0)
    : toPositiveInteger(staffId ? counts[staffId] : 0);

  if (count > 0) return count;

  const unreadStaffIds = contact.unreadStaffIds || [];
  if (!Array.isArray(unreadStaffIds) || unreadStaffIds.length === 0) {
    return 0;
  }

  if (isAdminView || !staffId || unreadStaffIds.includes(staffId)) {
    return 1;
  }

  return 0;
};

export const getUnreadMessageTotal = (
  contacts = [],
  { staffId, isAdminView = false } = {},
) =>
  (contacts || []).reduce(
    (total, contact) =>
      total +
      getContactUnreadMessageCount(contact, { staffId, isAdminView }),
    0,
  );
